import {
  SurveyPageProcessor,
  SurveyPageProcessorMeta,
  SurveyPageProcessorResponse
} from './SurveyPageProcessor'
import {SurveyBuilder} from '../SurveyBuilder'
import {Survey, SurveyElementAlert} from 'core/SurveyModels'

export class SurveyPageProcessorLog extends SurveyPageProcessor {
  process(): Promise<SurveyPageProcessorResponse> {
    return Promise.resolve({survey: this.survey, canProceed: true})
  }

  static instance(survey: Survey, meta: SurveyPageProcessorMeta) {
    return new SurveyPageProcessorLog(survey, meta)
  }
}

export class SurveyPageProcessorTest extends SurveyPageProcessor {
  process(): Promise<SurveyPageProcessorResponse> {
    return new Promise<SurveyPageProcessorResponse>((resolve) => {
      setTimeout(() => {
        resolve({survey: this.survey, canProceed: true})
      }, 1000)
    })
  }

  static instance = function (survey: Survey, meta: SurveyPageProcessorMeta) {
    return new SurveyPageProcessorTest(survey, meta)
  }
}

export class SurveyPageProcessorTemplate extends SurveyPageProcessor {
  process(): Promise<SurveyPageProcessorResponse> {
    return new Promise<SurveyPageProcessorResponse>((resolve) => {
      setTimeout(() => {
        const builder = new SurveyBuilder()
        builder.createPage({
          name: 'template',
          elements: [
            {
              type: 'text',
              name: 'question',
              title: {en: 'Template question'}
            }
          ]
        })
        try {
          const newSurvey = SurveyBuilder.tryExtendSurvey(
            this.survey,
            this.meta.pageIndex + 1,
            builder.pages()
          )
          resolve({survey: newSurvey, canProceed: true})
        } catch (e) {
          resolve({survey: this.survey, canProceed: true})
        }
      })
    })
  }

  static instance(survey: Survey, meta: SurveyPageProcessorMeta) {
    return new SurveyPageProcessorTemplate(survey, meta)
  }
}

export class SurveyPageProcessorAlert extends SurveyPageProcessor {
  process() {
    return new Promise<SurveyPageProcessorResponse>((r) => {
      let canProceed = true
      if (this.survey.pages[this.meta.pageIndex].elements[0].type !== 'alert') {
        canProceed = false
        this.survey.pages[this.meta.pageIndex].elements.unshift({
          type: 'alert',
          severity: 'warning',
          header: 'Warning',
          body: 'We could not found any suppliers with these options',
          name: 'alert-gen'
        } as SurveyElementAlert)
      } else if (
        this.survey.pages[this.meta.pageIndex].elements[0].type === 'alert'
      ) {
        this.survey.pages[this.meta.pageIndex].elements.splice(0, 1)
      }
      r({survey: this.survey, canProceed: canProceed})
    })
  }

  static instance(survey: Survey, meta: SurveyPageProcessorMeta) {
    return new SurveyPageProcessorAlert(survey, meta)
  }
}
